import style from './discovery.module.scss'
import { discoveryPageState } from './discovery.state';
import PreviewSectionComponent from './sections/preview-section';
import PopUpSectionComponent from './sections/pop-up-section';
import SDLCSectionComponent from './sections/sldc-section';
import DiscoveryPhaseSectionComponent from './sections/discovery-phase-section';
import SoftwareDiscoveryPhaseSectionComponent from './sections/software-discovery-phase-section';
import SoftwareDiscoveryOrderSectionComponent from './sections/sofware-discovery-order-section';
import DiscoveryPhaseTypesSectionComponent from './sections/discovery-phase-types-section';
import DiscoveryPhaseBenefitsSectionComponent from './sections/discovery-phase-benefits-section';
import DiscoveryPhaseStepsSectionComponent from './sections/discovery-phase-steps-section';
import LearnMoreSectionComponent from './sections/learn-more-section';
import DiscoveryArtifactsSectionComponent from './sections/discovery-artifacts-section';
import MainApproachesSectionComponent from './sections/main-approaches-section';
import DiscoveryProcessSectionComponent from './sections/discovery-process-section';
import DiscoveryProjectsSectionComponent from './sections/discovery-projects-section';
import DiscoveryEndSectionComponent from './sections/discovery-end-section';
import { StartProjectComponent } from '@components/shared/interactions/start-project-component';

const DiscoveryComponent = () => {
    const {
        previewSection,
        popUpSection,
        sdlcSection,
        discoveryPhaseSection,
        softwareDiscoveryPhaseSection,
        softwareDiscoveryOrderSection,
        discoveryPhaseTypesSection,
        discoveryPhaseBenefitsSection,
        discoveryPhaseStepsSection,
        learnMoreSection,
        discoveryArtifactsSection,
        mainApproachesSection,
        discoveryProcessSection,
        discoveryProjectsSection,
        discoveryEndSection,
    } = discoveryPageState;

    return (
        <>
            <PreviewSectionComponent section={previewSection} />
            <PopUpSectionComponent section={popUpSection} />
            <SDLCSectionComponent section={sdlcSection} />
            <DiscoveryPhaseSectionComponent section={discoveryPhaseSection} />
            <SoftwareDiscoveryPhaseSectionComponent section={softwareDiscoveryPhaseSection} />
            <SoftwareDiscoveryOrderSectionComponent section={softwareDiscoveryOrderSection} />
            <DiscoveryPhaseTypesSectionComponent section={discoveryPhaseTypesSection} />
            <DiscoveryPhaseBenefitsSectionComponent section={discoveryPhaseBenefitsSection} />
            <DiscoveryPhaseStepsSectionComponent section={discoveryPhaseStepsSection} />
            <LearnMoreSectionComponent section={learnMoreSection} />
            <DiscoveryArtifactsSectionComponent section={discoveryArtifactsSection} />
            <MainApproachesSectionComponent section={mainApproachesSection} />
            <DiscoveryProcessSectionComponent section={discoveryProcessSection} />
            <DiscoveryProjectsSectionComponent section={discoveryProjectsSection} />
            <DiscoveryEndSectionComponent section={discoveryEndSection} />
            <section id="discoveryPageForm" className={`${style.section} ${style.section__block_gray}`}>
                <div className={`${style.container} ${style.container_small}`}>
                    <StartProjectComponent title={"Start a project"} />
                </div>
            </section>
        </>
    )
}

export default DiscoveryComponent;
